var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6118 19.1648H14.2404V18.5275C14.2404 16.334 15.4261 15.6671 16.4339 15.2521C17.2491 14.9112 17.8716 14.7185 17.8716 13.7551C17.8716 12.8066 17.0416 12.3323 16.0634 12.3323C15.1 12.3323 14.2404 12.7177 14.1663 13.77H11.7949C11.7949 11.1466 13.8699 10.0647 16.0634 10.0647C18.3606 10.0647 20.2429 11.2059 20.2429 13.7996C20.2429 16.4377 18.6867 16.7045 17.5158 17.2084C16.9971 17.4308 16.6118 17.8161 16.6118 18.5423V19.1648ZM14.107 21.4917C14.107 20.6914 14.6257 20.1727 15.4409 20.1727C16.2412 20.1727 16.76 20.6914 16.76 21.4917C16.76 22.2921 16.2412 22.8256 15.4409 22.8256C14.6257 22.8256 14.107 22.2921 14.107 21.4917Z",
    fill: "#828AE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnQuestion);
export default __webpack_public_path__ + "static/media/icn-question.4ef8a209322795d1795522ac396d61bb.svg";
export { ForwardRef as ReactComponent };